import script from "./CadIdsSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./CadIdsSelector.vue?vue&type=script&setup=true&lang=ts"

import "./CadIdsSelector.vue?vue&type=style&index=0&id=4d6bf517&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d6bf517"]])

export default __exports__